export default {
  // 页面描述
  subscribeTitle: 'Are you sure you want to unsubscribe?',
  subscribeDesc: 'You will no longer receive emails from support@aha.inc to your inbox: ',
  cancelTitle: "You are now unsubscribed.",
  cancelDesc: "We're sorry to see you go. If you change your mind, you can subscribe again at any time.",
  resultTitle: 'You\'re subscribed',
  resultDesc: 'Thanks for staying with us.',
  // 页面按钮
  button: {
    unsubscribe: 'Unsubscribe',
    resubscribe: 'Resubscribe',
    waitKeepMeSubscribed: "Wait, keep me subscribed"
  }
  
};
